// extracted by mini-css-extract-plugin
export default {"link":"NavBar_link__tytt8","navtext":"NavBar_navtext__GBLhB"};